export const GET_FEATURE_FLAGS_REQUESTED =
  'GET_FEATURE_FLAGS_REQUESTED'
export const GET_FEATURE_FLAGS_SUCCEEDED =
  'GET_FEATURE_FLAGS_SUCCEEDED'
export const GET_FEATURE_FLAGS_FAILED = 'GET_FEATURE_FLAGS_FAILED'
